import { lazy } from 'react';
import { Redirect } from 'react-router-dom';

// layouts
import DashboardLayout from '../layouts/dashboard';

// auth
import ProtectedRoute from '../auth/ProtectedRoute';

import { PATH_DASHBOARD } from './paths';

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: PATH_DASHBOARD.root,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_DASHBOARD.general.dashboard,
      component: lazy(() => import('../views/Dashboard'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.sitemap,
      component: ProtectedRoute(lazy(() => import('../views/SiteMap')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.account,
      component: ProtectedRoute(lazy(() => import('../views/MyAccount')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.energy,
      component: ProtectedRoute(lazy(() => import('../views/Energy')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.plantInsights,
      component: ProtectedRoute(lazy(() => import('../views/PlantInsights')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.logs,
      component: ProtectedRoute(lazy(() => import('../views/Logs')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.templates,
      component: ProtectedRoute(lazy(() => import('../views/Templates')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.batches,
      component: ProtectedRoute(lazy(() => import('../views/Batches')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.wastewater,
      component: ProtectedRoute(lazy(() => import('../views/Wastewater')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.status,
      component: ProtectedRoute(lazy(() => import('../views/Status')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.paymentsuccess,
      component: ProtectedRoute(lazy(() => import('../views/PaymentSuccess')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.developer,
      component: ProtectedRoute(lazy(() => import('../views/Developer')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.configuration,
      component: ProtectedRoute(lazy(() => import('../views/Configuration')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.admin,
      component: ProtectedRoute(lazy(() => import('../views/Admin')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.contract,
      component: ProtectedRoute(lazy(() => import('../views/Contract')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.integrations,
      component: ProtectedRoute(lazy(() => import('../views/Integrations')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.network,
      component: ProtectedRoute(lazy(() => import('../views/Network')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.changelog,
      component: ProtectedRoute(lazy(() => import('../views/Changelog')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.assistant,
      component: ProtectedRoute(lazy(() => import('../views/Assistant')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.export,
      component: ProtectedRoute(lazy(() => import('../views/Export')))
    },
    {
      path: PATH_DASHBOARD.general.docs,
      component: ProtectedRoute(lazy(() => import('../views/Docs')))
    },

    // ERP (Phase 0) — gated by erpAccess inside ErpGuard
    {
      exact: true,
      path: PATH_DASHBOARD.erp.root,
      component: () => <Redirect to={PATH_DASHBOARD.erp.dashboard} />
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.dashboard,
      component: ProtectedRoute(lazy(() => import('../views/erp/ErpDashboard')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.productTypes,
      component: ProtectedRoute(lazy(() => import('../views/erp/ProductTypes')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.processFlows,
      component: ProtectedRoute(lazy(() => import('../views/erp/ProcessFlows')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.processFlows}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/ProcessFlowDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.ingredients,
      component: ProtectedRoute(lazy(() => import('../views/erp/Ingredients')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.suppliers,
      component: ProtectedRoute(lazy(() => import('../views/erp/Suppliers')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.recipes,
      component: ProtectedRoute(lazy(() => import('../views/erp/Recipes')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.recipes}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/RecipeDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.inventory,
      component: ProtectedRoute(lazy(() => import('../views/erp/Inventory')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.production,
      component: ProtectedRoute(lazy(() => import('../views/erp/Batches')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.production}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/BatchDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.packaging,
      component: ProtectedRoute(lazy(() => import('../views/erp/Packaging')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.settings,
      component: ProtectedRoute(lazy(() => import('../views/erp/ErpSettings')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.skus,
      component: ProtectedRoute(lazy(() => import('../views/erp/Skus')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.skus}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/SkuDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.excise,
      component: ProtectedRoute(lazy(() => import('../views/erp/Excise')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.orders,
      component: ProtectedRoute(lazy(() => import('../views/erp/Orders')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.orders}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/OrderDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.customers,
      component: ProtectedRoute(lazy(() => import('../views/erp/Customers')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.customers}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/CustomerDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.picking,
      component: ProtectedRoute(lazy(() => import('../views/erp/Picking')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.shipping,
      component: ProtectedRoute(lazy(() => import('../views/erp/Shipping')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.purchases,
      component: ProtectedRoute(lazy(() => import('../views/erp/Purchases')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.scheduling,
      component: ProtectedRoute(lazy(() => import('../views/erp/Scheduling')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.integrations,
      component: ProtectedRoute(lazy(() => import('../views/erp/ErpIntegrations')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.barrels,
      component: ProtectedRoute(lazy(() => import('../views/erp/Barrels')))
    },
    {
      exact: true,
      path: `${PATH_DASHBOARD.erp.barrels}/:id`,
      component: ProtectedRoute(lazy(() => import('../views/erp/BarrelDetail')))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.erp.userGuide,
      component: ProtectedRoute(lazy(() => import('../views/erp/ErpUserGuide')))
    },

    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default DashboardRoutes;
